import { render, staticRenderFns } from "./view.html?vue&type=template&id=1cbe6ad6&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=1cbe6ad6&lang=less&scoped=true&"
import style1 from "./phoneStyle.less?vue&type=style&index=1&lang=less&"
import style2 from "./otherStyle.less?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe6ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cbe6ad6')) {
      api.createRecord('1cbe6ad6', component.options)
    } else {
      api.reload('1cbe6ad6', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=1cbe6ad6&scoped=true&", function () {
      api.rerender('1cbe6ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/index.vue"
export default component.exports